var _desc, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bold/SVG/file-add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,9c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.3-0.3-0.4l-6.9-6.9c-0.1-0.1-0.2-0.2-0.4-0.3C13.3,1,13.1,1,13,1c0,0,0,0,0,0H7 C4.8,1,3,2.8,3,5v14c0,2.2,1.8,4,4,4h5c0.6,0,1-0.4,1-1s-0.4-1-1-1H7c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h5v4c0,1.7,1.3,3,3,3h4v3 c0,0.6,0.4,1,1,1s1-0.4,1-1L21,9C21,9,21,9,21,9z M15,8c-0.6,0-1-0.4-1-1V4.4L17.6,8H15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8,20v-7.6c0-0.6,0.4-1,1-1s1,0.4,1,1V20l1.1-1.1c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-2.1,2.1c-0.8,0.8-2,0.8-2.8,0 l-2.1-2.1c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0L15.8,20z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.f73504f62c9ba89e3a38f643a8a0f097.svg";
export { ForwardRef as ReactComponent };